import { ChangeDetectorRef, Component } from '@angular/core';
import { Router } from '@angular/router';
import { LoadingDisplayService } from '@core/services/loading-display.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor(
    public loadingDisplay: LoadingDisplayService,
    private cdr: ChangeDetectorRef,
    private router: Router
  ) { }
  
  ngOnInit(): void {
    this.router.events.subscribe(_ => this.cdr.detectChanges())
  }
}
